import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { Drawer } from 'ksnm-common-ui/lib/Drawer';
import { FormWrapper } from 'ksnm-common-ui/lib/Form/FormWrapper';

import { publicationRegisterStore } from '@stores/publicationRegisterStore';

import { Form } from './Form';

import styles from './AddReportDrawer.module.scss';

interface IAddReportDrawer {
  visible: boolean;
  onClose: () => void;
}

export const AddReportDrawer = observer(({ visible, onClose }: IAddReportDrawer) => {
  const { uncreatedReports, addUncreatedReportsIntoPackage } = publicationRegisterStore;

  const onSubmit = useCallback(
    async (values) => {
      if (!values.report.length) return { report: 'Обязательное поле' };

      const reports = uncreatedReports
        .filter((item) => values.report.some((r: string) => r === item.id))
        .map((item) => ({
          reportPackageCode: item.reportPackageCode,
          reportVersionCode: item.reportVersionCode,
        }));

      const result = await addUncreatedReportsIntoPackage(reports);
      if (result) onClose();
    },
    [addUncreatedReportsIntoPackage, onClose, uncreatedReports],
  );

  return (
    <Drawer open={visible} onClose={onClose} title="Новый отчет">
      <FormWrapper onSubmit={onSubmit} layout="vertical" className={styles.form}>
        <Form />
      </FormWrapper>
    </Drawer>
  );
});
